/*
 * App container - all containers and nested ones or nested components have this container as (grand-)* parent
 */ import "core-js/modules/es.regexp.exec.js";
let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { css, Global } from '@emotion/react';
import { Element } from '@klarna/ui';
import { updateDataLayer } from 'features/analytics/utils/dataLayerUtils';
import NotificationCenter from 'features/notifications/NotificationCenter';
import { isMigrationActive } from 'features/pricerunnerAccountMigration/accountMigrationStage';
import { useAccountMigrationStage } from 'features/pricerunnerAccountMigration/useAccountMigrationStage';
import { UserDialogProvider } from 'features/pricerunnerUserAccount/modules/userDialog/UserDialogContext';
import { InstallmentsModalProvider } from 'features/searchCompare/modules/installmentsModal/context/InstallmentsModalContext';
import MaybeKlarnaAuthManager from 'features/searchCompare/modules/klarnaAuthManager/MaybeKlarnaAuthManager';
import { loadRecentSearches } from 'features/searchCompare/modules/search/state/search';
import { getHideContent } from 'features/searchCompare/state/menu';
import { ProductInfoProvider } from 'features/searchCompare/utils/productInfoContext';
import { getSiteBannerVisibility } from 'features/searchCompare/utils/siteBannerUtils';
import { getDeviceCategory, getIsInternal } from 'framework/globalStorage/contextStore';
import { getFeatureFlag } from 'framework/globalStorage/settingsStore';
import { getIsFirstRender } from 'framework/state/request';
import { useAppDispatch, useAppSelector } from 'framework/store/hooks';
import loadable from 'framework/utils/codeSplitting/loadable';
import { getIsKlarnaSite, getIsPriceRunnerSite } from 'framework/utils/core/siteUtils';
import { useTranslate } from 'framework/utils/i18n/useTranslate';
import { withReducers } from 'framework/utils/redux/withReducers';
import { Outlet } from 'framework/utils/routing';
import { getHasCleanMode } from 'framework/utils/uriUtils/uriUtils';
import { Fragment, memo, useEffect } from 'react';
import { useLocation } from 'react-router';
import Konami from './components/Konami/Konami';
import { createOperationalDisturbancesNotification } from './operationalDisturbanceNotification';
import appContainerReducer, { APP_CONTAINER_KEY, getHideFooter, getHideHeader, getHideQuickAccess } from './state/appContainer';
const KWWProvider = loadable({
    resolved: {},
    chunkName () {
        return "features-searchCompare-modules-kww-KWWProvider";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: ()=>import(/*webpackChunkName: "features-searchCompare-modules-kww-KWWProvider"*/ 'features/searchCompare/modules/kww/KWWProvider'),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (require.resolveWeak) {
            return require.resolveWeak('features/searchCompare/modules/kww/KWWProvider');
        }
        return eval('require.resolve')('features/searchCompare/modules/kww/KWWProvider');
    }
});
const OnboardingDialog = loadable({
    resolved: {},
    chunkName () {
        return "features-searchCompare-modules-onboardingDialog-OnboardingDialog";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: ()=>import(/*webpackChunkName: "features-searchCompare-modules-onboardingDialog-OnboardingDialog"*/ 'features/searchCompare/modules/onboardingDialog/OnboardingDialog'),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (require.resolveWeak) {
            return require.resolveWeak('features/searchCompare/modules/onboardingDialog/OnboardingDialog');
        }
        return eval('require.resolve')('features/searchCompare/modules/onboardingDialog/OnboardingDialog');
    }
});
const AccountMigrationController = loadable({
    resolved: {},
    chunkName () {
        return "features-pricerunnerAccountMigration-AccountMigrationController";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: ()=>import(/*webpackChunkName: "features-pricerunnerAccountMigration-AccountMigrationController"*/ 'features/pricerunnerAccountMigration/AccountMigrationController'),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (require.resolveWeak) {
            return require.resolveWeak('features/pricerunnerAccountMigration/AccountMigrationController');
        }
        return eval('require.resolve')('features/pricerunnerAccountMigration/AccountMigrationController');
    }
});
const ContentEntryEditor = loadable({
    resolved: {},
    chunkName () {
        return "features-contentful-components-contentEntryEditor-ContentEntryEditor";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: ()=>import(/*webpackChunkName: "features-contentful-components-contentEntryEditor-ContentEntryEditor"*/ 'features/contentful/components/contentEntryEditor/ContentEntryEditor'),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (require.resolveWeak) {
            return require.resolveWeak('features/contentful/components/contentEntryEditor/ContentEntryEditor');
        }
        return eval('require.resolve')('features/contentful/components/contentEntryEditor/ContentEntryEditor');
    }
});
const PagePreviewButton = loadable({
    resolved: {},
    chunkName () {
        return "features-contentful-components-contentEntryEditor-components-PagePreviewButton";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: ()=>import(/*webpackChunkName: "features-contentful-components-contentEntryEditor-components-PagePreviewButton"*/ 'features/contentful/components/contentEntryEditor/components/PagePreviewButton'),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (require.resolveWeak) {
            return require.resolveWeak('features/contentful/components/contentEntryEditor/components/PagePreviewButton');
        }
        return eval('require.resolve')('features/contentful/components/contentEntryEditor/components/PagePreviewButton');
    }
});
const DebugTrigger = loadable({
    resolved: {},
    chunkName () {
        return "features-debug-DebugTrigger";
    },
    isReady (props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
            return !!__webpack_modules__[key];
        }
        return false;
    },
    importAsync: ()=>import(/*webpackChunkName: "features-debug-DebugTrigger"*/ 'features/debug/DebugTrigger'),
    requireAsync (props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then((resolved)=>{
            this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync (props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
            return __webpack_require__(id);
        }
        return eval('module.require')(id);
    },
    resolve () {
        if (require.resolveWeak) {
            return require.resolveWeak('features/debug/DebugTrigger');
        }
        return eval('require.resolve')('features/debug/DebugTrigger');
    }
});
// Global side-effect styles that cannot be expressed as component props:
// - hide the Google conversion tracking iframe injected into the document
// - `noscroll` toggled on <body>/#root by searchCompare/utils/modalUtils.setNoScrollOnBody()
const globalStyles = css(t || (t = _`
  iframe[name='google_conversion_frame'] {
    height: 0 !important;
    width: 0 !important;
    line-height: 0 !important;
    font-size: 0 !important;
    margin-top: -13px;
    float: left;
  }

  body.noscroll,
  body #root.noscroll {
    overflow: hidden;
    max-height: 100%;
  }
`));
const setDeviceCategoryInDataLayer = (deviceCategory)=>{
    updateDataLayer({
        deviceCategory: deviceCategory
    });
};
const AppContainer = ({ children })=>{
    const location = useLocation();
    const dispatch = useAppDispatch();
    const translate = useTranslate();
    const hideHeader = useAppSelector(getHideHeader);
    const hideFooter = useAppSelector(getHideFooter);
    const hideQuickAccess = useAppSelector(getHideQuickAccess);
    const isInternal = getIsInternal();
    const deviceCategory = getDeviceCategory();
    const isFirstRender = useAppSelector(getIsFirstRender);
    const showOperationalDisturbancesNotification = getFeatureFlag('operational_disturbances_first_render_notification');
    const hideContent = useAppSelector(getHideContent);
    const hasCleanMode = getHasCleanMode(location === null || location === void 0 ? void 0 : location.search);
    const showDataProtectionNotification = !hasCleanMode;
    const isGreetingModalEnabled = getFeatureFlag('enable_klarna_greeting_modal');
    const isRedirectScreenEnabled = getFeatureFlag('enable_redirect_screen');
    const isAccountMigrationActive = isMigrationActive(useAccountMigrationStage());
    useEffect(()=>{
        setDeviceCategoryInDataLayer(deviceCategory);
    }, [
        deviceCategory
    ]);
    useEffect(()=>{
        dispatch(loadRecentSearches());
    }, [
        dispatch
    ]);
    useEffect(()=>{
        if (isFirstRender && showOperationalDisturbancesNotification && process.IS_BROWSER) {
            dispatch(createOperationalDisturbancesNotification({
                durationMilliseconds: 200000,
                message: translate('PR.Notification.OPERATIONAL_DISTURBANCES_EXCUSE')
            }));
        }
    }, [
        isFirstRender,
        showOperationalDisturbancesNotification,
        translate,
        dispatch
    ]);
    const isKlarnaSite = getIsKlarnaSite();
    const isPriceRunnerSite = getIsPriceRunnerSite();
    const MaybeKWWProvider = isKlarnaSite ? KWWProvider : Fragment;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Global, {
                styles: globalStyles
            }),
            /*#__PURE__*/ _jsx(Konami, {}),
            /*#__PURE__*/ _jsxs(Element, {
                direction: "vertical",
                minHeight: "100vh",
                children: [
                    isGreetingModalEnabled && /*#__PURE__*/ _jsx(Outlet, {
                        slotName: "greetingModals"
                    }),
                    isRedirectScreenEnabled && /*#__PURE__*/ _jsx(Outlet, {
                        slotName: "redirectScreen"
                    }),
                    /*#__PURE__*/ _jsx(MaybeKlarnaAuthManager, {}),
                    /*#__PURE__*/ _jsx(UserDialogProvider, {
                        children: /*#__PURE__*/ _jsxs(MaybeKWWProvider, {
                            children: [
                                /*#__PURE__*/ _jsx(InstallmentsModalProvider, {
                                    children: /*#__PURE__*/ _jsxs(ProductInfoProvider, {
                                        children: [
                                            hideHeader ? null : /*#__PURE__*/ _jsx(Outlet, {
                                                slotName: "header"
                                            }),
                                            getSiteBannerVisibility('promoBanner') && /*#__PURE__*/ _jsx(Outlet, {
                                                slotName: "promotionBanner"
                                            }),
                                            /*#__PURE__*/ _jsxs(Element, {
                                                basis: "auto",
                                                display: hideContent ? 'none' : undefined,
                                                grow: 1,
                                                id: "content-below-header",
                                                minHeight: 400,
                                                order: 1,
                                                position: "relative",
                                                shrink: 0,
                                                children: [
                                                    children,
                                                    !hideQuickAccess && /*#__PURE__*/ _jsx(Outlet, {
                                                        slotName: "quickAccess"
                                                    })
                                                ]
                                            }),
                                            hideFooter ? null : /*#__PURE__*/ _jsx(Outlet, {
                                                slotName: "footer"
                                            }),
                                            isPriceRunnerSite && /*#__PURE__*/ _jsx(OnboardingDialog, {}),
                                            isPriceRunnerSite && isAccountMigrationActive && /*#__PURE__*/ _jsx(AccountMigrationController, {}),
                                            isInternal && /*#__PURE__*/ _jsx(DebugTrigger, {}),
                                            isInternal && /*#__PURE__*/ _jsx(ContentEntryEditor, {}),
                                            isInternal && /*#__PURE__*/ _jsx(PagePreviewButton, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(NotificationCenter, {})
                            ]
                        })
                    })
                ]
            }),
            showDataProtectionNotification && /*#__PURE__*/ _jsx(Outlet, {
                slotName: "dataProtection"
            })
        ]
    });
};
const reducers = [
    {
        name: APP_CONTAINER_KEY,
        reducer: appContainerReducer
    }
];
export default withReducers(reducers)(/*#__PURE__*/ memo(AppContainer));
